import styled from 'styled-components'

export const BodyPush = styled.div`
  height: 30px;
  width: 100%;
`
